
import Typography from '@mui/material/Typography';


export const TextDrugAtorvastatin = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Atorvastatin is used together with diet, weight loss, and exercise to reduce the risk of heart attack and stroke and to decrease the chance that heart surgery 
will be needed in people who have heart disease or who are at risk of developing heart disease. Atorvastatin is also used to decrease the amount of fatty substances 
such as low-density lipoprotein (LDL) cholesterol ('bad cholesterol') and triglycerides in the blood and 
to increase the amount of high-density lipoprotein (HDL) cholesterol ('good cholesterol') in the blood. 
Atorvastatin may also be used to decrease the amount of cholesterol and other fatty substances in the blood in children and teenagers 10 to 17 years of age 
who have familial heterozygous hypercholesterolemia (an inherited condition in which cholesterol cannot be removed from the body normally). 
Atorvastatin is in a class of medications called HMG-CoA reductase inhibitors (statins). 
It works by slowing the production of cholesterol in the body to decrease the amount of cholesterol 
that may build up on the walls of the arteries and block blood flow to the heart, brain, and other parts of the body.
<br /><br />


Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a600045.html

</Typography>

</div>

)
}